import { Button } from 'primeng/button';
import { CommonModule } from '@angular/common';
import { Component, inject, input, OnInit, output, signal, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { Divider } from 'primeng/divider';
import { FloatLabel } from 'primeng/floatlabel';
import { FormsModule, NgForm } from '@angular/forms';
import { LookupPipe } from '@web/csl-lib-pipes';
import { MrrUpdateDialogStore } from './store/mrr-update-dialog.store';
import { MrrUpdateService } from './services/mrr-update.service';
import { PatientBannerComponent } from '@web/csl-lib-components';
import { Select } from 'primeng/select';
import { StoredHealthRecordDocument } from '@web/csl-lib-models';
import { TableModule } from 'primeng/table';
import { Textarea } from 'primeng/textarea';

@Component({
  selector: 'csl-mrr-update-dialog',
  standalone: true,
  imports: [
    CommonModule,
    Button,
    Dialog,
    Divider,
    FloatLabel,
    FormsModule,
    LookupPipe,
    PatientBannerComponent,
    Select,
    TableModule,
    Textarea,
  ],
  templateUrl: './mrr-update-dialog.component.html',
  styleUrl: './mrr-update-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [MrrUpdateDialogStore, MrrUpdateService],
})
export class MrrUpdateDialogComponent implements OnInit {
  readonly updateForm = viewChild<NgForm>('updateForm');

  /* Inputs */

  patientLastFirstName = input<string>();
  patientDob = input<Date>();
  healthRecordId = input<string | null>();
  clinicId = input.required<number>();
  medicalRecordReleaseId = input.required<number | null>();
  visible = input<boolean>();

  /* Outputs */

  onUpdateComplete = output<boolean>();

  /* Member Vars */

  formUpdateMedicalRecordRelease = signal(new FormUpdateMedicalRecordRelease());
  mrrChanged: boolean = false;

  /* Stores */

  mrrUpdateStore = inject(MrrUpdateDialogStore);

  /* Lifecycle Hooks */

  ngOnInit() {
    if (this.healthRecordId() && this.medicalRecordReleaseId()) {
      this.mrrUpdateStore.loadMedicalRecordRelease({
        clinicId: this.clinicId(),
        healthRecordId: this.healthRecordId()!,
        mrrId: this.medicalRecordReleaseId()!,
      });
    }
  }

  /* Event Handlers */

  onClickClose() {
    this.onUpdateComplete.emit(this.mrrChanged);
  }

  onHideDialog() {
    setTimeout(() => {
      this.formUpdateMedicalRecordRelease.set(new FormUpdateMedicalRecordRelease());
      this.mrrUpdateStore.clear();
    }, 500);
  }

  onShowDialog() {
    this.mrrUpdateStore.loadMedicalRecordRelease({
      clinicId: this.clinicId(),
      healthRecordId: this.healthRecordId()!,
      mrrId: this.medicalRecordReleaseId()!,
    });

    this.mrrChanged = false;
  }

  onUpdateStatus() {
    this.mrrUpdateStore.updateStatus({
      clinicId: this.clinicId(),
      mrr: this.mrrUpdateStore.selectedItem()!,
      newState: this.formUpdateMedicalRecordRelease().newStatus!,
      comment: this.formUpdateMedicalRecordRelease().comment,
    });

    this.mrrChanged = true;

    setTimeout(() => {
      this.formUpdateMedicalRecordRelease.set(
        new FormUpdateMedicalRecordRelease());
      this.updateForm()?.resetForm();
    }, 500);
  }
}

class FormUpdateMedicalRecordRelease {
  newStatus: number | null = null;
  comment: string = '';
}
